import { StatCard } from '@/common/dashboard/StatCard';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';


// import { useNavState } from '@/common/navState/NavStateContext';
// import { Mode } from '@/common/entityFramework/enumerations/Mode';

export const FinanceDashboardCardChart = ({
  startPeriod,
  endPeriod,
  periodicity,
  prodIds,
  channelIds,
  entity,
  direction,
  changeType
}) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    if (!prodIds?.length) return;
    if (!channelIds?.length) return;

    const plugin = entity === 'SBC' ? 'SBC_METRICS_DASHBOARD_DATA_PLUGIN' : 'RESERVE_METRICS_DASHBOARD_DATA_PLUGIN';


    const ndc11ProdIds = prodIds.map((prod) => prod);
    const reqParam = { changeType, startPeriod, endPeriod, periodicity, ndc11ProdIds, channelIds, entity };

    rsrc
      .data('gtn', plugin, reqParam, entity)
      .then((rows) => setData(rows));
  }, [changeType, startPeriod, endPeriod, periodicity, prodIds, channelIds, entity]);

  /**
   * Finds the label with the largest change (increase or decrease)
   * between the first and last periods in a dataset where values
   * are already percentages.
   *
   * @param {Object} data - { categories: string[], series: Array<{ label: string, values: number[] }> }
   * @param {'increase'|'decrease'} direction - Direction to find the largest change
   * @returns {{ label: string|null, change: number|null }} - Label and absolute percent change
   */
  function getLargestShift(data, direction = 'Decrease') {
    const { categories, series } = data || {};
    if (!categories?.length || !series?.length) {
      return { label: null, change: null };
    }

    const firstIdx = 0;
    const lastIdx = categories.length - 1;

    let resultLabel = null;
    let resultChange = direction === 'Decrease' ? 0 : 0;

    for (const s of series) {
      const firstVal = s.values[firstIdx];
      const lastVal = s.values[lastIdx];

      if (firstVal == null || lastVal == null) continue;

      // Since values are already percentages, just take the difference
      const diff = lastVal - firstVal;

      if (direction === 'Decrease') {
        // largest downward shift (most negative)
        if (diff < resultChange) {
          resultChange = diff;
          resultLabel = s.label;
        }
      } else if (direction === 'Increase') {
        // largest upward shift (most positive)
        if (diff > resultChange) {
          resultChange = diff;
          resultLabel = s.label;
        }
      }
    }

    if (!resultLabel) return { label: null, change: null };

    return {
      label: resultLabel,
      change: resultChange, // absolute difference in percentage points
    };
  }

  let largestChange = {
    change: null,
    label: null
  };
  let changeTitle;
  let title;
  let showPercent;

  if (data) {
    largestChange = getLargestShift(data, direction);
    changeTitle = changeType === 'percent' ? '%' : 'Amount';
    title = 'Largest ' + changeTitle + ' ' + direction;
    showPercent = changeType === 'percent' ? true : false;
  }

  return (
    <StatCard
      title={title}
      pctChange={largestChange.change}
      vsLabel={startPeriod}
      cat={largestChange.label}
      showPercent={showPercent}
    />
  );
};
